import { createInstance, dateReviver } from '@/api';
import { CreatePublication, PublicationClient, PublicationCreated } from '@/api/frontoffice/clients';
import { useAlertStore } from '@/modules/core/store/alert.store';
import { defineStore } from 'pinia';
import { i18n } from '@/i18n';

export interface PublicationCreateStoreState {
    saving: boolean;
    uploadProgress: number;
}

export const client = new PublicationClient('', createInstance(), dateReviver);

export const usePublicationCreateStore = defineStore('publications-publication-create-store', {
    state: (): PublicationCreateStoreState => ({
        saving: false,
        uploadProgress: 0
    }),
    getters: {},
    actions: {
        async createPublication(body: CreatePublication, file?: File): Promise<PublicationCreated> {
            this.saving = true;
            useAlertStore().clearAlert();
            try {
                const files = [];
                if (file) {
                    files.push({ data: file, fileName: file.name });
                }
                const created = await client.createPublication(body, files, {
                    onUploadProgress: (progressEvent) => {
                        if (progressEvent.total) {
                            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        }
                    }
                });
                useAlertStore().setSuccess(i18n.global.t('publications.versions.detail.success.create.title'));
                return created;
            } catch (error) {
                useAlertStore().handleException(
                    i18n.global.t('publications.versions.detail.error.create.title'),
                    error
                );
                return null;
            } finally {
                this.saving = false;
            }
        },
        clear() {
            this.saving = false;
            this.uploadProgress = 0;
            useAlertStore().clearAlert();
        }
    }
});
